import React from "react"
import { useStaticQuery, graphql, Link } from 'gatsby'
import Img from "gatsby-image"
import { FormattedMessage } from 'react-intl';

import { StaticImage } from "gatsby-plugin-image"
const StyledLink = styled(LocalizedLink)`
opacity:1 !important;


`

import { useLightbox } from 'simple-react-lightbox'
import styled from '@emotion/styled'
import LocalizedLink from '../int/LocalizedLink'
import { fonts } from '../../styles/variables'
import { MdBurstMode } from 'react-icons/md'
// USE THE IMPORT BELOW INSTEAD IF YOU ARE USING THE PRO VERSION
// import { useLightbox } from 'simple-react-lightbox-pro'

const imgPaths = [
 "",
]



const Div = styled.div`
`


const ThumbWrapper = styled.div`


.gatsby-image-wrapper-constrained {
width:5.5rem;
//cursor:pointer;
height:auto;
border-radius:2px;
display:block;
margin:0;
opacity:0.8;
transition: all .7s ease;
:hover{
opacity:1;
}

 @media screen and (max-width: 666px) {
 margin-left:auto;
 margin-right:auto;
 //width:100%;
 height:auto;
  opacity:0.8;


}

}

`
const ThumbWrapper2 = styled.div`


.gatsby-image-wrapper-constrained {
width:7.5rem;
//cursor:pointer;
height:auto;
border-radius:2px;
display:block;
margin:0;
opacity:0.8;
transition: all .7s ease;
:hover{
opacity:1;
}

 @media screen and (max-width: 666px) {
 margin-left:auto;
 margin-right:auto;
 //width:100%;
 height:auto;
  opacity:0.8;


}

}

`
const ThumbWrapper3 = styled.div`


.gatsby-image-wrapper-constrained {
width:4.6rem;
//cursor:pointer;
height:auto;

display:block;
margin:0;
opacity:0.8;
transition: all .7s ease;
:hover{
opacity:1;
}

 @media screen and (max-width: 666px) {
 margin-left:auto;
 margin-right:auto;
 //width:100%;
 height:auto;
  opacity:0.8;


}

}

`


const OpenPhotos = styled.div`

//margin-right:2%;
 cursor:pointer;
font-weight:700;
height:40px;
//border-top:1px solid rgba(68,68,68,.04);;
border-radius:10rem;
//border-right:2px solid  rgba(84, 170, 241,.1);
//border-top:2px solid  rgba(84, 170, 241,.1);
width:49%;
 display: flex;
 align-items:center;
 justify-content:center;
 // border-radius: 10rem;
  color: rgb(68,68,68,.5);
  font-size: 1rem;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
  font-weight:bold;
  font-size:21px;

font-family:${fonts.button};
letter-spacing:2px;


:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 100%;
  background-color: rgba(84, 170, 241,.2);
  transition: all .3s;
 // border-radius: 10rem;
  z-index: -1;
}

 :after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color:rgba(84, 170, 241,.3) ;
 // border-radius: 10rem;
  z-index: -2;
}

:hover {
  color: rgb(68,68,68);
}

:hover:before {
  width: 100%;
}


   @media screen and (max-width: 1295px) {
//z-index:999;
}



`




export function PciCompliantImg() {
  return (
    <ThumbWrapper>
      <StaticImage
        src="../../content/pci-compliant.png"
        alt={""}
        placeholder="blurred"
        layout="constrained"
        quality="100"
      />

    </ThumbWrapper>
  )
}
export function SslSecureImg() {
  return (
    <ThumbWrapper3>
      <StaticImage
        src="../../content/ssl-secure.png"
        alt={""}
        placeholder="blurred"
        layout="constrained"
        quality="100"
      />

    </ThumbWrapper3>
  )
}
export function PaymentLogosImg() {
  return (
    <ThumbWrapper2>
      <StaticImage
        src="../../content/payment-logos.png"
        alt={""}
        placeholder="blurred"
        layout="constrained"
        quality="100"
      />

    </ThumbWrapper2>
  )
}
